/**
 * Step One-style Bundle Builder
 * - 4 quantity blocks (Single, 4 Pack, 7 Pack, 15 Pack) set required bundle size.
 * - SELECT SIZE → Single/Mixed tabs → progress X/Y → slots → Add to Cart.
 * - Appstle Subscriptions: grouped bundle subscriptions via appstle_subbox_id line property.
 */
(function () {
  function formatMoney(cents, format) {
    if (cents == null || cents === '') return '';
    if (typeof cents === 'string') cents = String(cents).replace('.', '');
    var num = Number(cents);
    if (isNaN(num)) return '';
    var value = (num / 100).toFixed(2);
    var valueNoDec = String(Math.round(num / 100));
    var formatStr = (format && typeof format === 'string') ? format : '{{amount}}';

    if (num % 100 !== 0) {
      formatStr = formatStr.replace(/amount_no_decimals/g, 'amount');
    }

    return formatStr
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, valueNoDec);
  }

  function getSectionsToRender() {
    return [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
  }

  function renderCartContents(parsedState) {
    if (!parsedState || !parsedState.sections) return;
    getSectionsToRender().forEach(function (s) {
      var dest = document.getElementById(s.id);
      if (!dest) return;
      var html = parsedState.sections[s.section];
      if (typeof html !== 'string') return;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector(s.selector) || doc.body;
        var target = dest.querySelector(s.selector) || dest;
        if (source && target) target.innerHTML = source.innerHTML;
      } catch (e) { return; }
    });
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) {
      if (typeof OverlayManager !== 'undefined') {
        if (OverlayManager.stack.includes(drawer)) {
          // BUG FIX: OverlayManager.open() silently bails when drawer is already in
          // the stack (e.g. user opened cart before clicking ATC). We force-reset it
          // so the updated cart contents are visible and interactive.
          drawer.inert = false;
          drawer.classList.add('active');
          document.body.classList.add('open-cc');
        } else {
          // Normal path: drawer is closed — open it via OverlayManager.
          OverlayManager.open(drawer);
        }
      } else {
        // Fallback when OverlayManager is not available.
        drawer.inert = false;
        drawer.classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
      }
    }
    // BUG FIX: use global dispatchCustomEvent (dispatches on document) instead of
    // window.dispatchCustomEvent — CartDrawer.connectedCallback listens on document.
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('cart-drawer:open');
    }
  }

  function getVariantsJson(container) {
    var script = container ? container.querySelector('[data-bundle-variants]') : null;
    if (!script || !script.textContent) script = document.querySelector('[data-bundle-variants]');
    if (!script || !script.textContent) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) { return null; }
  }

  function getOptionsJson(container) {
    var script = container ? container.querySelector('[data-bundle-options]') : null;
    if (!script || !script.textContent) script = document.querySelector('[data-bundle-options]');
    if (!script || !script.textContent) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) { return []; }
  }

  function getSellingPlansJson(container) {
    var script = container ? container.querySelector('[data-bundle-selling-plans]') : null;
    if (!script || !script.textContent) script = document.querySelector('[data-bundle-selling-plans]');
    if (!script || !script.textContent) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) { return []; }
  }

  /**
   * Generate a unique Appstle subbox group ID.
   * All items in the same bundle share this ID so Appstle treats them as one subscription.
   */
  function generateAppstleSubboxId() {
    var ts = Date.now().toString(36);
    var rand = Math.random().toString(36).slice(2, 7);
    return 'bf-bundle-' + ts + '-' + rand;
  }

  function normalizeSellingPlanId(id) {
    if (id == null) return '';
    return String(id).replace(/^gid:\/\/shopify\/SellingPlan\//, '');
  }

  function getSellingPlanIdFromAllocation(allocation) {
    if (!allocation) return null;
    if (allocation.selling_plan && allocation.selling_plan.id != null) return allocation.selling_plan.id;
    if (allocation.selling_plan_id != null) return allocation.selling_plan_id;
    if (allocation.id != null) return allocation.id;
    return null;
  }

  function getSellingPlanNameFromAllocation(allocation) {
    if (!allocation) return '';
    if (allocation.selling_plan && allocation.selling_plan.name) return allocation.selling_plan.name;
    if (allocation.name) return allocation.name;
    return '';
  }

  function findPlanInGroups(planGroups, planId) {
    var normalizedPlanId = normalizeSellingPlanId(planId);
    if (!normalizedPlanId || !planGroups || !planGroups.length) return null;
    for (var i = 0; i < planGroups.length; i++) {
      var plans = planGroups[i] && planGroups[i].selling_plans ? planGroups[i].selling_plans : [];
      for (var j = 0; j < plans.length; j++) {
        if (normalizeSellingPlanId(plans[j].id) === normalizedPlanId) return plans[j];
      }
    }
    return null;
  }

  function getVariantSellingPlanId(variant, preferredPlanId, preferredPlanName) {
    var allocations = variant.enhanced_allocations || variant.selling_plan_allocations || [];
    var planGroups = getSellingPlansJson(); // Get master groups from data-bundle-selling-plans

    var normalizedPreferredName = preferredPlanName ? String(preferredPlanName).toLowerCase().trim() : '';
    var normalizedPreferredId = normalizeSellingPlanId(preferredPlanId);

    // Helper to check if an allocation has a meaningful discount
    function getDiscount(alloc) {
      if (alloc.is_discounted) return alloc.discount_value || 1; // 1 if flag set but value 0
      if (alloc.discount_value != null && alloc.discount_value > 0) return alloc.discount_value;
      if (alloc.price_adjustments && alloc.price_adjustments[0]) return parseFloat(alloc.price_adjustments[0].value || 0);
      return 0;
    }

    // 1. Try to find a plan in the variant's allocations that matches the name AND has a discount
    if (normalizedPreferredName) {
      var bestNameMatch = null;
      var maxNameMatchDiscount = -1;
      for (var i = 0; i < allocations.length; i++) {
        var name = getSellingPlanNameFromAllocation(allocations[i]).toLowerCase().trim();
        if (name === normalizedPreferredName) {
          var d = getDiscount(allocations[i]);
          // Even if discount is 0, if the flag is set, treat it as a candidate
          if (allocations[i].is_discounted) d = d || 1;
          if (d > maxNameMatchDiscount) {
            maxNameMatchDiscount = d;
            bestNameMatch = getSellingPlanIdFromAllocation(allocations[i]);
          }
        }
      }
      if (bestNameMatch && maxNameMatchDiscount > 0) return bestNameMatch;
    }

    // 2. Backup: If no name-match discount found, check ALL variant allocations for ANY discount
    var bestAnyMatch = null;
    var maxAnyDiscount = 0;
    for (var j = 0; j < allocations.length; j++) {
      var d2 = getDiscount(allocations[j]);
      if (d2 > maxAnyDiscount) {
        maxAnyDiscount = d2;
        bestAnyMatch = getSellingPlanIdFromAllocation(allocations[j]);
      }
    }
    if (bestAnyMatch && maxAnyDiscount > 0) return bestAnyMatch;

    // 3. Last Resort for same-product variants: Try to find a discounted plan ID in the master groups
    // that matches our preferred name, assuming the ID might be shared or recoverable.
    if (normalizedPreferredName && planGroups) {
      for (var g = 0; g < planGroups.length; g++) {
        var groupPlans = planGroups[g].selling_plans || [];
        for (var p = 0; p < groupPlans.length; p++) {
          var gpName = (groupPlans[p].name || '').toLowerCase().trim();
          if (gpName === normalizedPreferredName) {
            // If we found a plan with the same name in the master list, 
            // check if the variant has an allocation for this specific ID.
            var gpId = normalizeSellingPlanId(groupPlans[p].id);
            for (var a = 0; a < allocations.length; a++) {
              if (normalizeSellingPlanId(getSellingPlanIdFromAllocation(allocations[a])) === gpId) {
                return getSellingPlanIdFromAllocation(allocations[a]);
              }
            }
          }
        }
      }
    }

    // 4. Fallback to name matching even without confirmed discount
    if (normalizedPreferredName) {
      for (var k = 0; k < allocations.length; k++) {
        var name2 = getSellingPlanNameFromAllocation(allocations[k]).toLowerCase().trim();
        if (name2 === normalizedPreferredName) return getSellingPlanIdFromAllocation(allocations[k]);
      }
    }

    // 5. Fallback to exact ID match
    if (normalizedPreferredId) {
      for (var l = 0; l < allocations.length; l++) {
        var allocationPlanId = getSellingPlanIdFromAllocation(allocations[l]);
        if (normalizeSellingPlanId(allocationPlanId) === normalizedPreferredId) return allocationPlanId;
      }
    }

    // 6. Absolute fallback: first allocation
    return allocations.length ? getSellingPlanIdFromAllocation(allocations[0]) : null;
  }

  function findVariantByOptions(variants, optionsMap) {
    if (!variants || !variants.length) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var key in optionsMap) {
        if (optionsMap[key] != null && v[key] !== optionsMap[key]) {
          match = false;
          break;
        }
      }
      if (match && v.available) return v;
    }
    return null;
  }

  function findCurrentVariant(container, sectionId) {
    var variants = getVariantsJson(container);
    if (!variants || !variants.length) return null;

    var variantId = null;
    var variantSelects = document.querySelector('#variant-selects-' + sectionId);
    if (variantSelects && variantSelects.currentVariant) {
      variantId = variantSelects.currentVariant.id;
    } else {
      var productForm = document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        var idInput = productForm.querySelector('input[name="id"]');
        if (idInput && idInput.value) variantId = idInput.value;
      }
      if (!variantId && window.location.search.indexOf('variant=') !== -1) {
        var match = window.location.search.match(/variant=(\d+)/);
        if (match) variantId = match[1];
      }
    }

    if (variantId) {
      var found = variants.find(function (v) { return String(v.id) === String(variantId); });
      if (found) return found;
    }

    return variants[0];
  }

  /**
   * Sync our JS-computed selling plan ID back to the DOM input.
   * This ensures that any other scripts (like Appstle) that read from the DOM
   * will see our discounted ID instead of the 0% Master Box placeholder.
   */
  function updateDomSellingPlan(container, planId) {
    var inputs = document.querySelectorAll('input[name="selling_plan"]');
    inputs.forEach(function (input) {
      input.value = planId || '';
      // Trigger change event so other apps' listeners might update
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function updateTierBlockPrices(variantPriceCents) {
    var wrapper = document.querySelector('[data-bundle-quantity-blocks]');
    if (!wrapper || variantPriceCents == null) return;
    var moneyFormat = wrapper.getAttribute('data-money-format') || '{{amount}}';
    var pct1 = parseInt(wrapper.getAttribute('data-tier-1-pct'), 10) || 0;
    var pct3 = parseInt(wrapper.getAttribute('data-tier-3-pct'), 10) || 0;
    var pct6 = parseInt(wrapper.getAttribute('data-tier-6-pct'), 10) || 0;
    var pct9 = parseInt(wrapper.getAttribute('data-tier-9-pct'), 10) || 0;

    // Check for subscription discount
    var subDiscountPct = 0;
    var container = document.querySelector('[data-section-id]');
    if (container && container.getAttribute('data-subscription-active') === 'true') {
      // We can assume 10% based on user's requirements, or try to find it dynamically
      subDiscountPct = 10;
    }

    var blocks = wrapper.querySelectorAll('[data-quantity-block]');
    blocks.forEach(function (btn) {
      var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
      var perPairCents = variantPriceCents;
      if (variantPriceCents === 4400) {
        if (qty >= 15) perPairCents = 2300;
        else if (qty >= 7) perPairCents = 2600;
        else if (qty >= 4) perPairCents = 2800;
        else perPairCents = 4400;
      } else {
        if (qty >= 15) perPairCents = Math.round(variantPriceCents * (100 - pct9) / 100);
        else if (qty >= 7) perPairCents = Math.round(variantPriceCents * (100 - pct6) / 100);
        else if (qty >= 4) perPairCents = Math.round(variantPriceCents * (100 - pct3) / 100);
        else perPairCents = Math.round(variantPriceCents * (100 - pct1) / 100);
      }

      // Apply subscription discount to the displayed price
      if (subDiscountPct > 0) {
        perPairCents = Math.round(perPairCents * (100 - subDiscountPct) / 100);
      }

      var priceEl = btn.querySelector('[data-block-price]');
      if (priceEl) priceEl.textContent = formatMoney(perPairCents, moneyFormat) + '/pair';
      btn.setAttribute('data-price-cents', perPairCents);
    });
  }

  function initQuantityBlocks() {
    var wrapper = document.querySelector('[data-bundle-quantity-blocks]');
    if (!wrapper) return;
    var blocks = wrapper.querySelectorAll('[data-quantity-block]');
    var sectionId = wrapper.getAttribute('data-section-id');
    blocks.forEach(function (btn) {
      btn.addEventListener('click', function () {
        blocks.forEach(function (b) {
          b.classList.remove('selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('selected');
        btn.setAttribute('aria-pressed', 'true');
        var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        document.documentElement.dispatchEvent(new CustomEvent('bundle:quantity-selected', { detail: { qty: qty, sectionId: sectionId } }));
      });
    });
    var defaultBlock = blocks[0];
    blocks.forEach(function (b) {
      if (parseInt(b.getAttribute('data-qty'), 10) === 4) {
        defaultBlock = b;
      }
    });

    if (defaultBlock) {
      defaultBlock.classList.add('selected');
      defaultBlock.setAttribute('aria-pressed', 'true');
      var qty = parseInt(defaultBlock.getAttribute('data-qty'), 10) || 1;
      document.documentElement.dispatchEvent(new CustomEvent('bundle:quantity-selected', { detail: { qty: qty, sectionId: sectionId } }));
    }
  }

  function initBundleBuilder(container) {
    if (!container || !container.dataset) return;
    var sectionId = container.dataset.sectionId;
    if (sectionId == null || sectionId === '') return;

    var moneyFormat = container.dataset.moneyFormat != null && container.dataset.moneyFormat !== '' ? container.dataset.moneyFormat : '{{amount}}';
    var maxSlots = parseInt(container.dataset.maxSlots, 10) || 15;
    var variants = getVariantsJson(container);
    var options = getOptionsJson(container);

    var selectSizeMsg = container.querySelector('[data-select-size-msg]');
    var sizeButtons = container.querySelectorAll('[data-size-value]');
    var styleDropdown = container.querySelector('[data-bundle-style-dropdown]');
    var variantCarousel = container.querySelector('[data-bundle-variant-carousel]');
    var slotsWrap = container.querySelector('[data-bundle-slots-wrap]');
    var modeTabs = container.querySelector('[data-bundle-mode-tabs]');
    var progressBar = container.querySelector('[data-bundle-progress-bar]');
    var progressCount = container.querySelector('[data-bundle-progress-count]');
    var qtyValueEl = container.querySelector('[data-bundle-qty-value]');
    var qtyMinusBtn = container.querySelector('[data-qty-minus]');
    var qtyPlusBtn = container.querySelector('[data-qty-plus]');
    var instructionTextEl = container.querySelector('[data-bundle-instruction-text]');
    var remainingTextEl = container.querySelector('[data-bundle-remaining-text]');
    var inlineAddBtn = container.querySelector('[data-inline-qty-add]');
    var inlineRemoveBtn = container.querySelector('[data-inline-qty-remove]');
    var selectedStyleValue = null;
    var sizeOptIndex = parseInt(container.dataset.sizeOptionIndex, 10) || 0;
    var styleOptIndex = parseInt(container.dataset.styleOptionIndex, 10) || 0;
    var atcBtn = container.querySelector('[data-bundle-atc]');
    var focusSizeBtn = container.querySelector('[data-focus-size]');
    var slotMessage = container.querySelector('[data-bundle-slot-message]');
    var slotElements = container.querySelectorAll('[data-slot]');
    var tier3Pct = parseInt(container.dataset.tier3Pct, 10) || 0;
    var tier6Pct = parseInt(container.dataset.tier6Pct, 10) || 0;
    var tier9Pct = parseInt(container.dataset.tier9Pct, 10) || 0;

    // Subscribe & Save state
    var selectedSellingPlanId = null; // null = one-time purchase
    var selectedSellingPlanName = '';
    var purchaseToggle = container.querySelector('[data-purchase-toggle]');
    var subscriptionBadge = container.querySelector('[data-subscription-badge]');

    var bundleItems = [];
    var currentVariant = null;
    var sqBlock = document.querySelector('[data-bundle-quantity-blocks] [data-quantity-block].selected');
    var selectedQuantity = sqBlock ? (parseInt(sqBlock.getAttribute('data-qty'), 10) || 1) : 1;
    var isMixedMode = true;

    function getRequiredSlots() {
      return Math.min(Math.max(1, selectedQuantity), maxSlots);
    }

    function setMixedOnlyVisibility() {
      var carouselWrap = container.querySelector('[data-bundle-variant-carousel]');
      var visible = isMixedMode && currentVariant;
      if (carouselWrap) carouselWrap.style.display = visible ? '' : 'none';
      container.classList.toggle('product-bundle-builder--single-mode', !isMixedMode);
    }
    function setVariant(v) {
      if (!v) {
        currentVariant = null;
        if (selectSizeMsg) selectSizeMsg.style.display = '';
        if (variantCarousel) variantCarousel.style.display = 'none';
        if (modeTabs) modeTabs.style.display = 'none';
        var stylePills = container.querySelector('[data-bundle-style-pills]');
        if (stylePills) stylePills.style.display = 'none';
        updateSelectionCount();
        renderSlots();
        updateProgress();
        updateAtc();
        updateDomSellingPlan(container, '');
        return;
      }
      currentVariant = v;

      // Sync selling plan ID to DOM
      if (selectedSellingPlanId) {
        var bestId = getVariantSellingPlanId(currentVariant, selectedSellingPlanId, selectedSellingPlanName);
        updateDomSellingPlan(container, bestId);
      } else {
        updateDomSellingPlan(container, '');
      }

      if (selectSizeMsg) selectSizeMsg.style.display = 'none';
      if (modeTabs) modeTabs.style.display = '';
      setMixedOnlyVisibility();
      updateTierBlockPrices(currentVariant.price);
      renderSlots();
      updateProgress();
      updateAtc();
      updateSelectionCount();
      updateGallery(currentVariant);
    }

    function updateSelectionCount() {
      var required = getRequiredSlots();
      var count = bundleItems.length;
      if (progressCount) progressCount.textContent = count + ' / ' + required;
    }

    function updateInstructionText() {
      if (!instructionTextEl) return;
      var required = getRequiredSlots();
      if (!required || required <= 0) {
        instructionTextEl.style.display = 'none';
        instructionTextEl.textContent = '';
        return;
      }
      instructionTextEl.style.display = '';
      instructionTextEl.textContent = 'Choose ' + required + ' style' + (required !== 1 ? 's' : '');
    }

    function updateRemainingText() {
      if (!remainingTextEl) return;
      var required = getRequiredSlots();
      var count = bundleItems.length;
      if (!required || required <= 0) {
        remainingTextEl.style.display = 'none';
        remainingTextEl.textContent = '';
        return;
      }
      var remaining = required - count;
      if (remaining <= 0) {
        // All selected — show completion message briefly
        remainingTextEl.textContent = 'All ' + required + ' styles selected ✓';
        remainingTextEl.classList.add('product-bundle-builder__remaining-text--complete');
        remainingTextEl.classList.remove('product-bundle-builder__remaining-text--needed');
        remainingTextEl.style.display = '';
      } else {
        remainingTextEl.textContent = remaining + ' more style' + (remaining !== 1 ? 's' : '') + ' needed';
        remainingTextEl.classList.add('product-bundle-builder__remaining-text--needed');
        remainingTextEl.classList.remove('product-bundle-builder__remaining-text--complete');
        remainingTextEl.style.display = '';
      }
    }

    function updateInlineControls() {
      var required = getRequiredSlots();
      if (inlineRemoveBtn) {
        inlineRemoveBtn.disabled = required <= 1;
        inlineRemoveBtn.classList.toggle('product-bundle-builder__inline-qty-btn--disabled', required <= 1);
      }
      if (inlineAddBtn) {
        inlineAddBtn.disabled = required >= maxSlots;
        inlineAddBtn.classList.toggle('product-bundle-builder__inline-qty-btn--disabled', required >= maxSlots);
      }
    }

    function updateQtyDisplay() {
      if (qtyValueEl) qtyValueEl.textContent = selectedQuantity;
    }

    function addByVariant(variantObj) {
      if (!variantObj || !variantObj.available) return;
      var required = getRequiredSlots();
      if (bundleItems.length >= required) {
        showSlotMessage('You\'ve reached your limit for this pack');
        return;
      }
      bundleItems.push(variantObj);
      renderSlots();
      updateProgress();
      updateAtc();
    }

    function renderSlots() {
      var required = getRequiredSlots();
      var count = bundleItems.length;
      slotElements.forEach(function (slot, index) {
        var variant = bundleItems[index] || null;
        var isEmpty = !variant;
        var plusWrap = slot.querySelector('.product-bundle-builder__slot-plus');
        var filledWrap = slot.querySelector('.product-bundle-builder__slot-filled');
        var img = slot.querySelector('[data-slot-img]');
        var removeBtn = slot.querySelector('[data-slot-remove]');
        var sizeSelect = slot.querySelector('[data-slot-size-select]');

        if (index >= required) {
          slot.style.display = 'none';
          return;
        }
        slot.style.display = '';

        var isAddMoreSlot = isEmpty && index === count;
        slot.classList.toggle('product-bundle-builder__slot--add-more', isAddMoreSlot);
        if (isEmpty) {
          slot.classList.add('product-bundle-builder__slot--empty');
          slot.classList.remove('product-bundle-builder__slot--filled');
          if (plusWrap) plusWrap.style.display = '';
          if (filledWrap) filledWrap.style.display = 'none';
          slot.setAttribute('aria-label', 'Add item to bundle');
        } else {
          slot.classList.remove('product-bundle-builder__slot--empty');
          slot.classList.add('product-bundle-builder__slot--filled');
          if (plusWrap) plusWrap.style.display = 'none';
          if (filledWrap) filledWrap.style.display = '';

          // ── Pre-compute product variants + option positions (used for both image & size dropdown) ──
          var slotProductId = String(variant.product_id);
          var productVarsForSlot = variants ? variants.filter(function (x) {
            return String(x.product_id) === slotProductId;
          }) : [];
          var szPatternsSlot = ['xs', 'xsmall', 's', 'small', 'm', 'medium', 'l', 'large', 'xl', 'xxl', '2xl', '3xl', 'one size'];
          var detectedSizeOptIdx = sizeOptIndex;
          var colorOptNumSlot = 0;
          for (var osi = 1; osi <= 3; osi++) {
            var osiVals = productVarsForSlot.map(function (x) { return (x['option' + osi] || '').toLowerCase(); });
            var osiIsSize = osiVals.some(function (ov) { return szPatternsSlot.indexOf(ov) !== -1 || /^\d+$/.test(ov); });
            if (osiIsSize && detectedSizeOptIdx === sizeOptIndex) detectedSizeOptIdx = osi - 1;
            if (!osiIsSize && osiVals.some(function (ov) { return ov !== ''; }) && colorOptNumSlot === 0) colorOptNumSlot = osi;
          }
          var slotColorVal = colorOptNumSlot ? (variant['option' + colorOptNumSlot] || '') : '';
          // ─────────────────────────────────────────────────────────────────────────────────────────

          if (variant && img) {
            var imgSrc = '';
            // 1st: match carousel card by product_id + exact color value
            var matchedCard = null;
            if (variantCarousel && slotColorVal) {
              matchedCard = variantCarousel.querySelector(
                '[data-product-id="' + slotProductId + '"][data-color-value="' + slotColorVal.replace(/"/g, '&quot;') + '"]'
              );
            }
            // 2nd: any card with this product_id
            if (!matchedCard && variantCarousel) {
              matchedCard = variantCarousel.querySelector('[data-product-id="' + slotProductId + '"]');
            }
            if (matchedCard) {
              var cardImg = matchedCard.querySelector('img');
              if (cardImg && cardImg.src) imgSrc = cardImg.src;
            }
            // 3rd: variant's own featured_image from JSON
            if (!imgSrc) {
              var feat = variant.featured_image;
              if (feat && feat.src) {
                imgSrc = feat.src;
                if (imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
              }
            }
            if (imgSrc) { img.src = imgSrc; } else { img.removeAttribute('src'); }
          }
          if (removeBtn) removeBtn.style.display = '';
          if (sizeSelect) {
            sizeSelect.style.display = '';
            if (variant) {
              var sizeVal = variant['option' + (detectedSizeOptIdx + 1)];
              var colorOptIdx2 = detectedSizeOptIdx === 0 ? 1 : 0;
              var colorVal2 = variant['option' + (colorOptIdx2 + 1)];
              var allSizes = [];
              productVarsForSlot.forEach(function (x) {
                if (!x.available) return;
                var xc = x['option' + (colorOptIdx2 + 1)];
                if (colorVal2 && xc !== colorVal2) return;
                var xs = x['option' + (detectedSizeOptIdx + 1)];
                if (xs && allSizes.indexOf(xs) === -1) allSizes.push(xs);
              });
              if (allSizes.length) {
                sizeSelect.innerHTML = '<option value="">—</option>' +
                  allSizes.map(function (sz) {
                    var sel = (sizeVal != null && sz === String(sizeVal)) ? ' selected' : '';
                    return '<option value="' + sz.replace(/"/g, '&quot;') + '"' + sel + '>' + sz + '</option>';
                  }).join('');
              } else if (sizeVal != null) {
                var existingOpt = sizeSelect.querySelector('option[value="' + String(sizeVal).replace(/"/g, '&quot;') + '"]');
                if (existingOpt) sizeSelect.value = sizeVal;
              }
            }
          }
          slot.setAttribute('aria-label', 'Remove item from bundle');
        }

      });
    }

    function updateProgress() {
      var required = getRequiredSlots();
      var count = bundleItems.length;
      var pct = required > 0 ? Math.min(100, (count / required) * 100) : 0;
      if (progressBar) progressBar.style.width = pct + '%';
      updateSelectionCount();
      updateRemainingText();
    }

    function updateAtc() {
      if (!atcBtn) return;
      var required = getRequiredSlots();
      var count = bundleItems.length;
      var canAdd;
      if (isMixedMode) {
        canAdd = currentVariant && required > 0 && count === required && bundleItems.every(function (v) { return v && v.available; });
      } else {
        canAdd = currentVariant && currentVariant.available && selectedQuantity >= 1;
      }
      atcBtn.disabled = !canAdd;

      // Update ATC button text to indicate how many more styles are needed
      var textEl = atcBtn.querySelector('[data-atc-text]');
      if (textEl) {
        var atcDefaultText = container.getAttribute('data-atc-text') || 'Add to Cart';
        if (!canAdd && isMixedMode && required > 0 && count < required) {
          var stillNeeded = required - count;
          textEl.textContent = 'Select ' + stillNeeded + ' more style' + (stillNeeded !== 1 ? 's' : '');
        } else {
          textEl.textContent = atcDefaultText;
        }
      }
    }

    function showSlotMessage(text) {
      if (!slotMessage) return;
      slotMessage.textContent = text;
      slotMessage.style.display = 'block';
      setTimeout(function () { slotMessage.style.display = 'none'; slotMessage.textContent = ''; }, 3500);
    }

    function updateGallery(v) {
      if (!v) return;
      var slider = document.getElementById('Product-Slider');
      if (!slider) return;

      var mainProductId = container.dataset.productId;
      var sectionId = container.dataset.sectionId;

      var firstSlide = slider.querySelector('.product-images__slide');
      var firstImg = firstSlide ? firstSlide.querySelector('img') : null;

      // 1. Try to find if this variant's media exists in the gallery
      if (v.featured_media && String(v.product_id) === String(mainProductId)) {
        // Restore original image if it was previously overwritten by an external product
        if (firstImg && firstImg.dataset.originalSrc) {
          firstImg.src = firstImg.dataset.originalSrc;
          firstImg.srcset = firstImg.dataset.originalSrcset;
        }

        var mediaId = '#' + 'Slide-' + sectionId + '-' + v.featured_media.id;
        if (typeof slider.selectCell === 'function') {
          slider.selectCell(mediaId);
          return;
        } else {
          var slide = slider.querySelector('[data-media-id="' + sectionId + '-' + v.featured_media.id + '"]');
          if (slide) {
            slider.scrollTo({
              left: slide.offsetLeft,
              behavior: 'smooth'
            });
            return;
          }
        }
      }

      // 2. If not found or not main product, force update the first slide's image
      if (firstSlide && firstImg) {
        // Store original image source on first run so we can restore it later
        if (!firstImg.dataset.originalSrc) {
          firstImg.dataset.originalSrc = firstImg.src;
          firstImg.dataset.originalSrcset = firstImg.srcset || '';
        }

        var src = v.featured_image ? v.featured_image.src : null;
        if (!src && v.image) src = v.image;
        if (src) {
          if (src.indexOf('//') === 0) src = 'https:' + src;
          // Use a larger version than the thumbnail if possible (handles query strings)
          src = src.replace(/(_\d+x\d+)?(\.(?:jpg|jpeg|png|gif|webp))(?:\?.*)?$/i, '_960x$2');

          firstImg.src = src;
          firstImg.srcset = ''; // Clear srcset to force our new src

          if (typeof slider.selectCell === 'function') {
            slider.selectCell(0);
          } else {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          }
        }
      }
    }

    function updateSubscriptionBadge() {
      if (!subscriptionBadge) return;
      if (selectedSellingPlanId) {
        var plans = getSellingPlansJson(container);
        var planName = '';
        var discountText = '';
        if (plans.length && plans[0].selling_plans && plans[0].selling_plans.length) {
          var plan = plans[0].selling_plans[0];
          planName = plan.name || '';
          if (plan.price_adjustments && plan.price_adjustments.length) {
            var adj = plan.price_adjustments[0];
            if (adj.value_type === 'percentage') {
              discountText = 'Save ' + adj.value + '% — ' + planName;
            } else if (adj.value_type === 'fixed_amount') {
              discountText = 'Save ' + formatMoney(adj.value * 100) + ' — ' + planName;
            } else {
              discountText = 'Subscribing: ' + planName;
            }
          } else {
            discountText = 'Subscribing: ' + planName;
          }
        }
        subscriptionBadge.textContent = discountText || 'Subscription applied';
        subscriptionBadge.style.display = 'block';
      } else {
        subscriptionBadge.textContent = '';
        subscriptionBadge.style.display = 'none';
      }
    }

    // Purchase type toggle (Subscribe & Save)
    if (purchaseToggle) {
      var purchaseBtns = purchaseToggle.querySelectorAll('[data-purchase-type]');
      purchaseBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var type = btn.getAttribute('data-purchase-type');
          if (type === 'subscription') {
            var plans = getSellingPlansJson(container);
            if (!plans.length || !plans[0].selling_plans || !plans[0].selling_plans.length) {
              alert('No subscription plan is configured for this product. Please set up a Selling Plan in the Appstle Subscriptions app first, then assign it to this product.');
              return;
            }
            var bestInitPlan = plans[0].selling_plans[0];
            // Try to find a plan with a discount on the initial variant
            if (initialVariant) {
              var vAllocs = initialVariant.enhanced_allocations || initialVariant.selling_plan_allocations || [];
              var bestVAlloc = null;
              var maxVDiscount = -1;
              for (var ai = 0; ai < vAllocs.length; ai++) {
                var dVal = vAllocs[ai].discount_value || (vAllocs[ai].is_discounted ? 1 : 0);
                if (dVal > maxVDiscount) {
                  maxVDiscount = dVal;
                  bestVAlloc = vAllocs[ai];
                }
              }
              if (bestVAlloc && maxVDiscount > 0) {
                // Find the plan in master groups that matches this best allocation ID
                var targetId = normalizeSellingPlanId(getSellingPlanIdFromAllocation(bestVAlloc));
                for (var pi = 0; pi < plans[0].selling_plans.length; pi++) {
                  if (normalizeSellingPlanId(plans[0].selling_plans[pi].id) === targetId) {
                    bestInitPlan = plans[0].selling_plans[pi];
                    break;
                  }
                }
              }
            }
            selectedSellingPlanId = bestInitPlan.id;
            selectedSellingPlanName = bestInitPlan.name || plans[0].name || '';

            // Sync to DOM immediately
            if (currentVariant) {
              var bestIdOnToggle = getVariantSellingPlanId(currentVariant, selectedSellingPlanId, selectedSellingPlanName);
              updateDomSellingPlan(container, bestIdOnToggle);
            }
          } else {
            selectedSellingPlanId = null;
            selectedSellingPlanName = '';
            updateDomSellingPlan(container, '');
          }
          if (selectedSellingPlanId && !selectedSellingPlanName) {
            var selectedPlan = findPlanInGroups(getSellingPlansJson(container), selectedSellingPlanId);
            selectedSellingPlanName = selectedPlan && selectedPlan.name ? selectedPlan.name : '';
          }
          purchaseBtns.forEach(function (b) {
            var isActive = b === btn;
            b.classList.toggle('active', isActive);
            b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          container.setAttribute('data-subscription-active', type === 'subscription' ? 'true' : 'false');
          if (currentVariant) updateTierBlockPrices(currentVariant.price);

          updateSubscriptionBadge();
        });
      });
    }

    // ── Handle ?subscription=true URL param initialization ──────────────────
    if (new URLSearchParams(window.location.search).get('subscription') === 'true') {
      setTimeout(function () {
        var subBtn = container.querySelector('[data-purchase-type="subscription"]');
        if (subBtn) {
          subBtn.click();
        } else {
          var plans = getSellingPlansJson(container);
          if (plans.length && plans[0].selling_plans && plans[0].selling_plans.length) {
            selectedSellingPlanId = plans[0].selling_plans[0].id;
            selectedSellingPlanName = plans[0].selling_plans[0].name || '';
            container.setAttribute('data-subscription-active', 'true');
            if (currentVariant) updateTierBlockPrices(currentVariant.price);
            updateSubscriptionBadge();
          }
        }
      }, 500); // Small delay to ensure variants are ready
    }
    // ────────────────────────────────────────────────────────────────────────

    function addSlot() {
      var selectedNow = findCurrentVariant(container, sectionId);
      if (!selectedNow || !selectedNow.available) return;
      var required = getRequiredSlots();
      if (bundleItems.length >= required) return;
      bundleItems.push(selectedNow);
      if (slotMessage) { slotMessage.style.display = 'none'; slotMessage.textContent = ''; }
      renderSlots();
      updateProgress();
      updateAtc();
    }

    function removeSlot(index) {
      if (index < 0 || index >= bundleItems.length) return;
      bundleItems.splice(index, 1);
      renderSlots();
      updateProgress();
      updateAtc();
    }

    function setSlotVariant(index, variant) {
      var v = variant || findCurrentVariant(container, sectionId);
      if (!v || !v.available) return;
      if (index >= bundleItems.length) {
        bundleItems.push(v);
      } else {
        bundleItems[index] = v;
      }
      renderSlots();
      updateProgress();
      updateAtc();
    }

    document.documentElement.addEventListener('bundle:quantity-selected', function (e) {
      if (e.detail && (String(e.detail.sectionId) === String(sectionId) || e.detail.sectionId == null)) {
        selectedQuantity = Math.min(maxSlots, Math.max(1, parseInt(e.detail.qty, 10) || 1));
        bundleItems = bundleItems.slice(0, selectedQuantity);
        updateQtyDisplay();
        updateSelectionCount();
        updateInstructionText();
        renderSlots();
        updateProgress();
        updateAtc();
        updateInlineControls();
      }
    });

    document.documentElement.addEventListener('product:variant-change', function (e) {
      if (e.detail && (String(e.detail.sectionId) === String(sectionId) || e.detail.sectionId == null) && e.detail.variant) {
        setVariant(e.detail.variant);
      }
    });

    var checkVariant = function () {
      var v = findCurrentVariant(container, sectionId);
      setVariant(v);
    };

    checkVariant();
    setTimeout(checkVariant, 50);
    setTimeout(checkVariant, 300);
    setMixedOnlyVisibility();
    updateInstructionText();
    updateRemainingText();
    updateInlineControls();

    function getSizeOptionIndex() {
      for (var o = 0; o < options.length; o++) {
        if (options[o].name && options[o].name.toLowerCase() === 'size') return o;
      }
      return 0;
    }

    function filterCarouselBySize(sizeVal) {
      if (!variantCarousel || !sizeVal) return;
      var optKey = 'data-variant-option' + (sizeOptIndex + 1);
      variantCarousel.querySelectorAll('[data-variant-id]').forEach(function (card) {
        card.style.display = card.getAttribute(optKey) === sizeVal ? '' : 'none';
      });
    }

    function applySizeAndSetVariant(sizeVal) {
      if (!variants || !variants.length || !sizeVal) return;
      var styleVal = selectedStyleValue;
      var v = null;
      if (options.length > 1 && styleVal != null) {
        v = variants.find(function (x) {
          if (!x.available) return false;
          var sizeKey = 'option' + (sizeOptIndex + 1);
          var styleKey = 'option' + (styleOptIndex + 1);
          return String(x[sizeKey]) === String(sizeVal) && String(x[styleKey]) === String(styleVal);
        });
      }
      if (!v) v = variants.find(function (x) { return String(x['option' + (sizeOptIndex + 1)]) === String(sizeVal) && x.available; });
      if (v) {
        setVariant(v);
        filterCarouselBySize(sizeVal);
        var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (idInput) idInput.value = v.id;
        if (typeof window.dispatchCustomEvent === 'function') {
          document.documentElement.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v, sectionId: sectionId } }));
        }
      } else {
        setVariant(null);
        if (variantCarousel) variantCarousel.querySelectorAll('[data-variant-id]').forEach(function (card) { card.style.display = ''; });
      }
    }

    if (sizeButtons.length) {
      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeButtons.forEach(function (b) { b.classList.remove('selected'); b.setAttribute('aria-pressed', 'false'); });
          btn.classList.add('selected');
          btn.setAttribute('aria-pressed', 'true');
          var sizeVal = btn.getAttribute('data-size-value');
          applySizeAndSetVariant(sizeVal);
        });
      });
    }
    if (modeTabs) {
      var modeButtons = modeTabs.querySelectorAll('.product-bundle-builder__mode-tab');
      modeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-mode') || 'single';
          isMixedMode = mode === 'mixed';
          modeButtons.forEach(function (b) {
            var isActive = b === btn;
            b.classList.toggle('active', isActive);
            b.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          setMixedOnlyVisibility();
          renderSlots();
          updateProgress();
          updateAtc();
        });
      });
    }

    if (styleDropdown) {
      styleDropdown.addEventListener('change', function () {
        selectedStyleValue = styleDropdown.value || null;
        var activeSize = container.querySelector('[data-size-value].selected');
        if (activeSize) applySizeAndSetVariant(activeSize.getAttribute('data-size-value'));
      });
    }
    var stylePillBtns = container.querySelectorAll('[data-style-value]');
    stylePillBtns.forEach(function (pill) {
      pill.addEventListener('click', function () {
        selectedStyleValue = pill.getAttribute('data-style-value');
        var activeSize = container.querySelector('[data-size-value].selected');
        if (activeSize) applySizeAndSetVariant(activeSize.getAttribute('data-size-value'));
      });
    });

    if (variantCarousel) {
      var carouselInner = container.querySelector('[data-bundle-variant-carousel-inner]');
      variantCarousel.querySelectorAll('[data-variant-id]').forEach(function (card) {
        card.addEventListener('click', function () {
          if (card.disabled) return;

          var cardProductId = card.getAttribute('data-product-id');
          var cardColorVal = card.getAttribute('data-color-value') || '';

          // ── Resolve the correct variant based on selected size + color ───
          // Cards show one color per product (representative variant). We need
          // to find the actual variant matching the user's selected size + color.
          var selectedSizeBtn = container.querySelector('[data-size-value].selected');
          var selectedSizeVal = selectedSizeBtn ? selectedSizeBtn.getAttribute('data-size-value') : null;

          var v = null;

          if (cardProductId && variants) {
            var productVars = variants.filter(function (x) { return String(x.product_id) === String(cardProductId); });

            // Detect size and color option positions for this product
            var sizeOptN = 0;
            var colorOptN = 0;
            for (var optN = 1; optN <= 3; optN++) {
              var optVals = productVars.map(function (x) { return (x['option' + optN] || '').toLowerCase(); });
              var szPatt = ['xs', 'xsmall', 's', 'small', 'm', 'medium', 'l', 'large', 'xl', 'xxl', '2xl', '3xl', 'one size'];
              var isSize = optVals.some(function (ov) { return szPatt.indexOf(ov) !== -1 || /^\d+$/.test(ov); });
              if (isSize && sizeOptN === 0) sizeOptN = optN;
              else if (!isSize && colorOptN === 0) colorOptN = optN;
            }
            if (sizeOptN === 0) sizeOptN = 1;
            if (colorOptN === 0) colorOptN = sizeOptN === 1 ? 2 : 1;

            // Try: same color + selected size
            if (selectedSizeVal) {
              v = productVars.find(function (x) {
                if (!x.available) return false;
                var xColor = (x['option' + colorOptN] || '').toLowerCase();
                var xSize = String(x['option' + sizeOptN]).toLowerCase().trim();
                var sSize = String(selectedSizeVal).toLowerCase().trim();
                return xColor === cardColorVal.toLowerCase().trim() && xSize === sSize;
              });
            }
            // Fallback: same color, any available size
            if (!v) {
              v = productVars.find(function (x) {
                if (!x.available) return false;
                var xColor = (x['option' + colorOptN] || '').toLowerCase();
                return xColor === cardColorVal.toLowerCase();
              });
            }
            // Last resort: any available variant of this product
            if (!v) {
              v = productVars.find(function (x) { return x.available; });
            }
          }

          // Fallback to looking up the card's own representative variant ID
          if (!v) {
            var vid = card.getAttribute('data-variant-id');
            v = variants && variants.find(function (x) { return String(x.id) === String(vid); });
          }
          if (!v) return;
          // ──────────────────────────────────────────────────────────────────

          // Mark this card as visually selected
          variantCarousel.querySelectorAll('[data-variant-id]').forEach(function (c) {
            c.classList.remove('product-bundle-builder__variant-card--selected');
          });
          card.classList.add('product-bundle-builder__variant-card--selected');

          // Update the next empty slot's size dropdown to show available sizes
          // for this product+color, and pre-select the currently chosen size.
          var nextEmptyIndex = bundleItems.length;
          if (nextEmptyIndex < slotElements.length) {
            var targetSlot = slotElements[nextEmptyIndex];
            if (targetSlot) {
              var slotSizeSelect = targetSlot.querySelector('[data-slot-size-select]');
              if (slotSizeSelect && cardProductId && variants) {
                var pv = variants.filter(function (x) { return String(x.product_id) === String(cardProductId); });
                var szN = sizeOptN || 1;
                var clN = colorOptN || 2;
                var availSizes = [];
                pv.forEach(function (x) {
                  if (!x.available) return;
                  var xColor = (x['option' + clN] || '').toLowerCase();
                  if (cardColorVal && xColor !== cardColorVal.toLowerCase()) return;
                  var sz = x['option' + szN];
                  if (sz && availSizes.indexOf(sz) === -1) availSizes.push(sz);
                });
                if (availSizes.length) {
                  slotSizeSelect.innerHTML = '<option value="">—</option>' +
                    availSizes.map(function (sz) {
                      var sel = (selectedSizeVal && sz === selectedSizeVal) ? ' selected' : '';
                      return '<option value="' + sz.replace(/"/g, '&quot;') + '"' + sel + '>' + sz + '</option>';
                    }).join('');
                }
              }
            }
          }

          addByVariant(v);
          updateGallery(v);
        });
      });
      container.querySelectorAll('[data-carousel-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!carouselInner) return;
          var dir = btn.getAttribute('data-carousel-nav') === 'prev' ? -1 : 1;
          carouselInner.scrollBy({ left: dir * 120, behavior: 'smooth' });
        });
      });
    }

    // ── Category tabs: Underwear | Cap ──────────────────────────────────────
    var activeCategoryTab = 'underwear'; // default
    var categoryTabsEl = container.querySelector('[data-bundle-category-tabs]');

    /**
     * Filter carousel cards by category only.
     * Color cards are NEVER filtered by size — the selected size is resolved
     * at click time so all colors remain visible regardless of chosen size.
     */
    function applyCategoryFilter() {
      if (!variantCarousel) return;
      variantCarousel.querySelectorAll('[data-variant-id]').forEach(function (card) {
        var cardCategory = (card.getAttribute('data-category') || '').toLowerCase();
        card.style.display = (cardCategory === activeCategoryTab) ? '' : 'none';
      });
    }

    if (categoryTabsEl) {
      var categoryTabBtns = categoryTabsEl.querySelectorAll('[data-category-tab]');
      categoryTabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          activeCategoryTab = btn.getAttribute('data-category-tab') || 'underwear';
          categoryTabBtns.forEach(function (b) {
            var isActive = b === btn;
            b.classList.toggle('active', isActive);
            b.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          applyCategoryFilter();
        });
      });
      // Apply default on load (show underwear by default)
      applyCategoryFilter();
    }

    // Patch filterCarouselBySize: for multi-product color carousels, size changes
    // must NOT hide cards (all colors stay visible). Just re-apply category filter.
    filterCarouselBySize = function (sizeVal) {
      // sizeVal is ignored — card visibility is category-only.
      // The correct variant is resolved per-click in the card click handler.
      applyCategoryFilter();
    };
    // ────────────────────────────────────────────────────────────────────────

    var slotsTrack = container.querySelector('[data-bundle-slots]');
    if (slotsTrack) {
      container.querySelectorAll('[data-slots-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-slots-nav') === 'prev' ? -1 : 1;
          var step = 92;
          slotsTrack.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
    }

    var findMyFitBtn = container.querySelector('[data-find-my-fit]');
    if (findMyFitBtn) {
      findMyFitBtn.addEventListener('click', function () {
        var sizeGuideModal = document.getElementById('sizeGuideModal');
        if (sizeGuideModal) {
          sizeGuideModal.style.display = 'flex';
          return;
        }
        var popup = document.querySelector('.product-popup-modal__button[aria-haspopup="dialog"]');
        if (popup) popup.click();
        else {
          var vs = document.querySelector('#variant-selects-' + sectionId);
          if (vs) {
            var fieldset = vs.querySelector('fieldset');
            if (fieldset) { var input = fieldset.querySelector('select, input[type="radio"]'); if (input) input.focus(); }
          }
        }
      });
    }
    if (focusSizeBtn) {
      focusSizeBtn.addEventListener('click', function () {
        var vs = document.querySelector('#variant-selects-' + sectionId);
        if (vs) {
          var fieldset = vs.querySelector('fieldset');
          if (fieldset) {
            var input = fieldset.querySelector('select, input[type="radio"]');
            if (input) { input.focus(); if (input.tagName === 'SELECT') input.click(); }
          }
        }
      });
    }

    if (modeTabs) {
      modeTabs.querySelectorAll('[data-mode]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          modeTabs.querySelectorAll('[data-mode]').forEach(function (t) {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');
          isMixedMode = tab.getAttribute('data-mode') === 'mixed';
          setMixedOnlyVisibility();
          renderSlots();
        });
      });
    }

    slotElements.forEach(function (slot, index) {
      slot.addEventListener('click', function (e) {
        // Ignore clicks on the remove button and size dropdown (they have their own handlers)
        if (e.target.closest('[data-slot-remove]') || e.target.closest('[data-slot-size-select]')) return;
        // Ignore clicks on filled content (slot image, etc.) — prevents accidentally replacing
        // a slot's saved variant with the currently-active main-form variant
        if (bundleItems[index] && e.target.closest('.product-bundle-builder__slot-filled')) return;
        if (bundleItems[index]) {
          // Filled slot clicked outside filled content — do nothing
          return;
        }
        if (bundleItems.length < getRequiredSlots()) {
          var carouselVisible = variantCarousel && variantCarousel.style.display !== 'none';
          if (carouselVisible) variantCarousel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          else addSlot();
        }
      });
      var removeBtn = slot.querySelector('[data-slot-remove]');
      if (removeBtn) {
        removeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          removeSlot(index);
        });
      }
      var sizeSelect = slot.querySelector('[data-slot-size-select]');
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function (e) {
          e.stopPropagation();
          var val = sizeSelect.value;
          if (!val || !variants) return;

          var currentSlotV = bundleItems[index];
          var v;

          if (currentSlotV) {
            // ── Multi-product aware size lookup ───────────────────────────────
            // 1. Try matching by product_id + color value + new size.
            //    The color card stores data-color-value; the variant carries it in
            //    the same option position. We identify the size option by scanning
            //    all option names for "size".
            var slotProductId = currentSlotV.product_id;
            var colorOptionName = (container.getAttribute('data-color-option-name') || 'colour').toLowerCase();

            // Build a map of option positions for the slot's product variants
            // by peeking at the variants with the same product_id.
            var sampleVariant = variants.find(function (x) { return String(x.product_id) === String(slotProductId); });
            var sizeOptNum = 0; // 1-indexed option number for size
            var colorOptNum = 0; // 1-indexed option number for color

            if (sampleVariant) {
              // Use existing options JSON for the main product's option names,
              // or guess by position. For cross-product variants, fall back to
              // scanning for "size" value changes between variants of same product.
              // Heuristic: option that has common size values (S/M/L/XL/number) = size.
              var productVariants = variants.filter(function (x) { return String(x.product_id) === String(slotProductId); });
              for (var optN = 1; optN <= 3; optN++) {
                var optVals = productVariants.map(function (x) { return (x['option' + optN] || '').toLowerCase(); });
                var sizePatterns = ['xs', 'xsmall', 's', 'small', 'm', 'medium', 'l', 'large', 'xl', 'xxl', '2xl', '3xl', 'one size'];
                var looksLikeSize = optVals.some(function (v2) { return sizePatterns.indexOf(v2) !== -1 || /^\d+$/.test(v2); });
                if (looksLikeSize && sizeOptNum === 0) sizeOptNum = optN;
                else if (!looksLikeSize && colorOptNum === 0) colorOptNum = optN;
              }
              if (sizeOptNum === 0) sizeOptNum = 1; // fallback
              if (colorOptNum === 0) colorOptNum = sizeOptNum === 1 ? 2 : 1;
            }

            var currentColorVal = currentSlotV['option' + colorOptNum];
            v = variants.find(function (x) {
              if (!x.available) return false;
              if (String(x.product_id) !== String(slotProductId)) return false;
              if (String(x['option' + sizeOptNum]) !== String(val)) return false;
              // Keep same color
              if (currentColorVal != null && x['option' + colorOptNum] !== currentColorVal) return false;
              return true;
            });

            // Fallback: same product, same size, any color
            if (!v) {
              v = variants.find(function (x) {
                return x.available &&
                  String(x.product_id) === String(slotProductId) &&
                  String(x['option' + sizeOptNum]) === String(val);
              });
            }
            // ──────────────────────────────────────────────────────────────────
          } else {
            // No existing slot variant — simple first-match
            v = variants.find(function (x) { return x.available; });
          }

          if (v) {
            setSlotVariant(index, v);
            updateGallery(v);
          }
        });
      }
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled || atcBtn.classList.contains('loading')) return;
        var required = getRequiredSlots();
        if (isMixedMode && (bundleItems.length !== required)) return;
        if (!isMixedMode && (!currentVariant || !currentVariant.available || selectedQuantity < 1)) return;

        atcBtn.classList.add('loading');
        atcBtn.setAttribute('aria-disabled', 'true');
        var textEl = atcBtn.querySelector('[data-atc-text]');
        var loadingEl = atcBtn.querySelector('.product-bundle-builder__atc-loading');
        if (textEl) textEl.style.display = 'none';
        if (loadingEl) loadingEl.style.display = '';

        var cartAddUrl = typeof theme !== 'undefined' && theme.routes ? theme.routes.cart_add_url : '/cart/add';
        var sectionsParam = getSectionsToRender().map(function (s) { return s.section; }).join(',');
        var sectionsUrl = window.location.pathname;

        function addSingleToCart() {
          var formData = new FormData();
          formData.append('id', String(currentVariant.id));
          formData.append('quantity', String(selectedQuantity));
          if (selectedSellingPlanId) {
            var singleSellingPlanId = getVariantSellingPlanId(currentVariant, selectedSellingPlanId, selectedSellingPlanName);
            if (!singleSellingPlanId) {
              return Promise.resolve({
                status: 422,
                description: 'Subscription is not available for the selected item. Please choose another style or check this variant in Appstle.'
              });
            }
            formData.append('selling_plan', String(singleSellingPlanId));
            // Appstle subscription grouping properties — even for single-colour mode
            // appstle_subbox_id groups items; appstle_subbox_name shows in customer portal
            var subboxId = generateAppstleSubboxId();
            var productTitle = container.getAttribute('data-bundle-product-title') || 'Big Fish Bundle';
            formData.append('properties[appstle_subbox_id]', subboxId);
            formData.append('properties[appstle_subbox_name]', productTitle + ' Subscription');
            formData.append('properties[appstle_subbox_line_count]', '1');
          }
          formData.append('sections', sectionsParam);
          formData.append('sections_url', sectionsUrl);
          return fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            body: formData
          }).then(function (res) { return res.json(); });
        }

        // BULK add: sends all bundle items in a single HTTP request instead of N sequential ones
        function addBulkToCart() {
          // Generate one shared subbox ID so Appstle groups all items as a single subscription
          var subboxId = selectedSellingPlanId ? generateAppstleSubboxId() : null;
          var productTitle = container.getAttribute('data-bundle-product-title') || 'Big Fish Bundle';
          var lineCount = bundleItems.length;
          var missingSubscriptionItems = [];

          var items = bundleItems.map(function (item, idx) {
            var props = { '_bundle_slot': String(idx + 1) };
            if (selectedSellingPlanId && subboxId) {
              // Appstle bundle grouping: same appstle_subbox_id on every line item
              // tells Appstle to manage all lines as one subscription group
              props['appstle_subbox_id'] = subboxId;
              props['appstle_subbox_name'] = productTitle + ' Bundle Subscription';
              props['appstle_subbox_line_count'] = String(lineCount);
            }
            var entry = { id: item.id, quantity: 1, properties: props };
            if (selectedSellingPlanId) {
              var itemSellingPlanId = getVariantSellingPlanId(item, selectedSellingPlanId, selectedSellingPlanName);
              if (itemSellingPlanId) {
                entry.selling_plan = itemSellingPlanId;
              } else {
                missingSubscriptionItems.push(item.title || item.name || ('item ' + (idx + 1)));
              }
            }
            return entry;
          });
          if (missingSubscriptionItems.length) {
            return Promise.resolve({
              status: 422,
              description: 'Subscription is not available for: ' + missingSubscriptionItems.join(', ') + '. Please check these variants in Appstle before adding the subscription bundle.'
            });
          }
          return fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: items, sections: sectionsParam, sections_url: sectionsUrl })
          }).then(function (res) { return res.json(); });
        }

        var chain;
        if (!isMixedMode) {
          chain = addSingleToCart();
        } else {
          chain = addBulkToCart();
        }
        chain
          .then(function (data) {
            if (data && data.status && data.status !== 200) {
              var errMsg = data.description || data.message || 'Could not add to cart.';
              if (data.status === 422 && selectedSellingPlanId && !data.description && !data.message) {
                errMsg = 'Subscription not available for one or more items in your bundle. Please ensure this product has an Appstle subscription plan assigned, then try again.';
              }
              alert(errMsg);
              return;
            }

            var addedItem = data && data.items && data.items[0] ? data.items[0] : data;

            // Shopify Bulk Add JSON payload quirk: /cart/add.js often drops `sections` 
            // when `items` array is sent as application/json.
            if (data && data.sections) {
              renderCartContents(data);
              if (typeof dispatchCustomEvent === 'function') {
                dispatchCustomEvent('cart:item-added', { product: addedItem });
              }
            } else {
              // Fallback: Shopify Section Rendering API
              // Pulling sections from the current path is much more reliable than /cart.js on modern Shopify.
              // It returns `{"cart-drawer": "..."}`, so we wrap it in a `.sections` object so renderCartContents understands it.
              fetch(sectionsUrl + '?sections=' + sectionsParam)
                .then(function (res) { return res.json(); })
                .then(function (sectionsData) {
                  renderCartContents({ sections: sectionsData });
                  if (typeof dispatchCustomEvent === 'function') {
                    dispatchCustomEvent('cart:item-added', { product: addedItem });
                  }
                })
                .catch(function (e) { console.error('Fallback fetch error:', e); });
            }
          })
          .catch(function (err) {
            var msg = (err && err.description) ? err.description : (err && err.message) ? err.message : null;
            if (msg) alert(msg);
            else if (err) console.error('[Bundle ATC]', err);
          })
          .finally(function () {
            atcBtn.classList.remove('loading');
            atcBtn.removeAttribute('aria-disabled');
            if (textEl) textEl.style.display = '';
            if (loadingEl) loadingEl.style.display = 'none';
          });
      });
    }

    var initialVariant = findCurrentVariant(container, sectionId);
    if (initialVariant && sizeButtons.length) {
      var initialSize = initialVariant['option' + (sizeOptIndex + 1)];
      if (initialSize) {
        sizeButtons.forEach(function (btn) {
          if (btn.getAttribute('data-size-value') === initialSize) {
            btn.classList.add('selected');
            btn.setAttribute('aria-pressed', 'true');
          }
        });
        if (variantCarousel) filterCarouselBySize(initialSize);
      }
      if (options.length > 1) selectedStyleValue = initialVariant['option' + (styleOptIndex + 1)];
    }
    setVariant(initialVariant);
    updateSelectionCount();
    updateQtyDisplay();

    var quantityBlocks = document.querySelectorAll('[data-bundle-quantity-blocks] [data-quantity-block]');
    var blockQuantities = [];
    quantityBlocks.forEach(function (b) {
      var q = parseInt(b.getAttribute('data-qty'), 10);
      if (!isNaN(q)) blockQuantities.push(q);
    });
    blockQuantities.sort(function (a, b) { return a - b; });
    var maxQty = blockQuantities.length ? blockQuantities[blockQuantities.length - 1] : 15;

    function getBlockQtyForHighlight(qty) {
      if (qty >= (blockQuantities[3] || 15)) return blockQuantities[3] || 15;
      if (qty >= (blockQuantities[2] || 7)) return blockQuantities[2] || 7;
      if (qty >= (blockQuantities[1] || 4)) return blockQuantities[1] || 4;
      return blockQuantities[0] || 1;
    }
    function syncBlocksHighlight() {
      var highlightQty = getBlockQtyForHighlight(selectedQuantity);
      quantityBlocks.forEach(function (b) {
        var bq = parseInt(b.getAttribute('data-qty'), 10);
        if (bq === highlightQty) {
          b.classList.add('selected');
          b.setAttribute('aria-pressed', 'true');
        } else {
          b.classList.remove('selected');
          b.setAttribute('aria-pressed', 'false');
        }
      });
    }

    if (qtyMinusBtn) {
      qtyMinusBtn.addEventListener('click', function () {
        if (selectedQuantity <= 1) return;
        selectedQuantity = selectedQuantity - 1;
        syncBlocksHighlight();
        updateQtyDisplay();
        document.documentElement.dispatchEvent(new CustomEvent('bundle:quantity-selected', { detail: { qty: selectedQuantity, sectionId: sectionId } }));
      });
    }
    if (qtyPlusBtn) {
      qtyPlusBtn.addEventListener('click', function () {
        if (selectedQuantity >= maxQty) return;
        selectedQuantity = selectedQuantity + 1;
        syncBlocksHighlight();
        updateQtyDisplay();
        document.documentElement.dispatchEvent(new CustomEvent('bundle:quantity-selected', { detail: { qty: selectedQuantity, sectionId: sectionId } }));
      });
    }
    syncBlocksHighlight();

    // ── Inline qty controls (+ Add 1 more / − Remove 1) ──────────────────────
    if (inlineAddBtn) {
      inlineAddBtn.addEventListener('click', function () {
        if (selectedQuantity >= maxQty) return;
        selectedQuantity += 1;
        syncBlocksHighlight();
        updateQtyDisplay();
        updateInstructionText();
        renderSlots();
        updateProgress();
        updateAtc();
        updateInlineControls();
      });
    }
    if (inlineRemoveBtn) {
      inlineRemoveBtn.addEventListener('click', function () {
        if (selectedQuantity <= 1) return;
        selectedQuantity -= 1;
        // Trim any excess selected items to fit the new smaller limit
        if (bundleItems.length > selectedQuantity) {
          bundleItems = bundleItems.slice(0, selectedQuantity);
        }
        syncBlocksHighlight();
        updateQtyDisplay();
        updateInstructionText();
        renderSlots();
        updateProgress();
        updateAtc();
        updateInlineControls();
      });
    }
    updateInlineControls();
    // ─────────────────────────────────────────────────────────────────────────
  }

  document.documentElement.addEventListener('product:variant-change', function (e) {
    if (e.detail && e.detail.variant && e.detail.variant.price != null) {
      updateTierBlockPrices(e.detail.variant.price);
    }
  });

  function setBundleTabActive(active) {
    var tabs = document.querySelector('.product-info-tabs[data-product-tabs]');
    if (!tabs) return;
    tabs.setAttribute('data-active', active);
    var singleBtn = document.getElementById('product-tab-single-btn');
    var bundleBtn = document.getElementById('product-tab-bundle-btn');
    if (singleBtn) { singleBtn.classList.toggle('active', active === 'single'); singleBtn.setAttribute('aria-selected', active === 'single'); }
    if (bundleBtn) { bundleBtn.classList.toggle('active', active === 'bundle'); bundleBtn.setAttribute('aria-selected', active === 'bundle'); }
    if (active === 'bundle' && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search + '#bundle');
    }
  }

  function scrollToBundleAndOpenTab() {
    setBundleTabActive('bundle');
  }

  document.documentElement.addEventListener('click', function (e) {
    var tabBtn = e.target.closest('.product-info-tabs__btn[data-tab]');
    if (!tabBtn || !tabBtn.closest('.product-info-tabs')) return;
    e.preventDefault();
    e.stopPropagation();
    var tab = tabBtn.getAttribute('data-tab');
    if (tab) setBundleTabActive(tab);
    if (tab === 'bundle' && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search + '#bundle');
    }
  });

  function init() {
    initQuantityBlocks();
    var containers = document.querySelectorAll('.product-bundle-builder[data-section-id]');
    if (containers.length) containers.forEach(initBundleBuilder);
    if (window.location.hash === '#bundle') setTimeout(scrollToBundleAndOpenTab, 100);
  }

  window.addEventListener('hashchange', function () {
    if (window.location.hash === '#bundle') scrollToBundleAndOpenTab();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
